module.exports = __webpack_public_path__ + "img/foto5.2bae1a28.jpg";